module.exports = __webpack_public_path__ + "img/yx.c6205526.jpg";